module.exports = __webpack_public_path__ + "img/ubuntu.cf7f5977.svg";